import type { FreeSlot } from '@hedepy/common/schemas/modules/schedule/freeSlot'

import type { ServiceType } from '@/legacy-src/types/GeneralStateType'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

import { useTherapistCart } from '@/src/domains/cart/hooks/useTherapistCart'

import { ClientBookingSelectAction } from './ClientBookingAvailableSlot.constants'
import { ClientBookingAvailableSlotConfirmation } from './ClientBookingAvailableSlotConfirmation/ClientBookingAvailableSlotConfirmation'
import { ClientBookingAvailableSlotRebook } from './ClientBookingAvailableSlotRebook'

export interface ClientBookingAvailableSlotProps {
  slot: FreeSlot
  therapist: TherapistType
  service: ServiceType
}

export const ClientBookingAvailableSlot = ({ slot, therapist, service }: ClientBookingAvailableSlotProps) => {
  const { selectedSlots, addSlot, removeSlot } = useTherapistCart()

  return (
    <ClientBookingAvailableSlotRebook
      slot={slot}
      therapist={therapist}
      fallback={
        <ClientBookingAvailableSlotConfirmation
          slot={slot}
          therapist={therapist}
          service={service}
          isSelected={selectedSlots.some((s) => s.startDate === slot.startDate)}
          onSelect={(type, action) => {
            addSlot(
              {
                startDate: slot.startDate,
                type,
              },
              {
                proceedToCart: action === ClientBookingSelectAction.PROCEED,
              },
            )
          }}
          onDeselect={() => {
            removeSlot(slot.startDate)
          }}
        />
      }
    />
  )
}
